import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonButton,
  IonBackdrop,
} from '@ionic/react';
import HStack from 'components/HStack';
import { isError } from 'lodash';
import {
  ZephyrResponse,
  ZephyrStateUpdate,
  ZephyrErrorData,
  ZephyrUploadProgress,
  ZephyrStatus,
} from 'types';
import { isInDebugMode } from '../../../util';
import Trans from 'util/Trans';

interface UpdateOverlayProps {
  updateStatus: ZephyrResponse | Error;
  dismiss: () => void;
}

const UpdateOverlay = (props: UpdateOverlayProps) => {
  const { updateStatus, dismiss } = props;
  const dismissableStates: Partial<ZephyrStatus>[] = [
    'upgradeCompleted',
    'upgradeFailed',
    'upgradeCanceled',
  ];
  /*
       {"status":"started"}
       {"status":"upgradeStarted"}
       {"status":"stateChanged","data":{"prevState":"none","newState":"requestMcuMgrParameters"}}
       {"status":"stateChanged", "data":{"prevState":"requestMcuMgrParameters","newState":"validate"}}
       {"status":"stateChanged", "data":{"prevState":"validate","newState":"upload"}}
       {"status":"uploadProgressChanged","data":{"bytesSent":2360,"imageSize":187044}}
           ...
       {"status":"uploadProgressChanged","data":{"bytesSent":187044,"imageSize":187044}}
       {"status":"stateChanged","data":{"prevState":"upload","newState":"test"}}
       {"status":"stateChanged","data":{"newState":"reset","prevState":"test"}}
       {"status":"stateChanged", "data":{"newState":"confirm","prevState":"reset"}}
       {"status":"stateChanged", "data":{"prevState":"confirm","newState":"success"}}
       {"status":"upgradeCompleted"} or {"status":"upgradeFailed"}
    */
  let statusData = '';
  const status = (() => {
    if (isError(updateStatus)) return updateStatus.message;
    if (updateStatus.status === 'stateChanged')
      return (updateStatus.data! as ZephyrStateUpdate).newState;
    if (updateStatus.status === 'upgradeFailed' && updateStatus.data && 'msg' in updateStatus.data) {
      statusData = (updateStatus.data as ZephyrErrorData).msg;
    }
    return updateStatus.status;
  })();

  let imageSize: number | null = null;
  let bytesSent: number | null = null;
  if (
    !isError(updateStatus) &&
    updateStatus.status === 'uploadProgressChanged'
  ) {
    const uploadInfo = updateStatus.data! as ZephyrUploadProgress;
    imageSize = uploadInfo.imageSize;
    bytesSent = uploadInfo.bytesSent;
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <IonCard
        style={{ zIndex: 100, top: '50%', transform: 'translateY(-50%)' }}
      >
        <IonCardHeader>
          <IonCardTitle>
            <Trans i18nKey="UPDATING_FIRMWARE">
              Firmware wird aktualisiert...
            </Trans>
          </IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          Status: {status} {statusData}
          {imageSize &&
            bytesSent &&
            ` ${bytesSent} / ${imageSize} (${(
              (bytesSent / imageSize) *
              100
            ).toFixed(1)}%)`}
          {/* Fehlerfall: Deutliche Anzeige und ggf. Debug-Infos */}
          {status === 'upgradeFailed' && (
            <div style={{ color: 'var(--ion-color-danger)', fontWeight: 'bold', marginTop: 12 }}>
              <Trans i18nKey="UPDATE_FAILED">Update fehlgeschlagen!</Trans>
              {statusData && (
                <div style={{ fontSize: 13, marginTop: 4 }}>
                  Fehler: {statusData}
                </div>
              )}
              {isInDebugMode() && (
                <div style={{ fontSize: 12, marginTop: 4, color: 'var(--ion-color-medium)' }}>
                  Debug: {JSON.stringify(updateStatus, null, 2)}
                </div>
              )}
            </div>
          )}
        </IonCardContent>
        <HStack>
          <IonButton
            onClick={dismiss}
            style={{
              visibility:
                isError(updateStatus) ||
                  dismissableStates.includes(status as any)
                  ? 'visible'
                  : 'hidden',
            }}
          >
            Ok
          </IonButton>
        </HStack>
      </IonCard>
      <IonBackdrop visible={true} tappable={false} />
    </div>
  );
};

export default UpdateOverlay;
